import React from "react";
import axios from "axios";
import Usernav from "./Usernav";
import { useState } from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./MyOrders.css";
import Loader from "../Util/Loader";
import emptyOrder from "../assets/image/Empty Order List.svg";
import BaseURL from "../Util/BaseURL";
const MyOrders = () => {
  var nav = useNavigate();
  const [orders, setorders] = useState();
  const [search,setSeach]=useState("")
  var path=window.location.pathname
  async function getCartDetails() {
    const r = await axios.get(
      `${BaseURL}getMyOrders?name=${sessionStorage.getItem(
        "user"
      )}`,
      { headers: { Authorization: "Bearer " + sessionStorage.getItem("pic") } }
    );
    setorders(r.data);
  }
  useEffect(() => {
    if(path==='/MyOrders')
        searchProduct()
   },[search])
   const searchProduct=()=> {
    var nodes = document.getElementsByClassName('target');
    var i
    for (i = 0; i < nodes.length; i++) {
      var str=search.toLowerCase()
      if (nodes[i].innerText.toLowerCase().includes(str)) {
         if(nodes[i].style.display==="none")
             nodes[i].style=''
      } else {
        nodes[i].style.display = "none";
      }
    }
  }
  useEffect(() => {
    getCartDetails();
  }, []);
  function ordersummary(props) {
    nav("/OrderSummary", { state: { orderNo: props } });
  }
  return (
    <>
      <Usernav />
      <div className='d-block d-lg-none d-xl-none'>
            <input id='search' className="searchUser" type="text" placeholder="Search your orders" name="search" value={search} 
            onChange={(e)=>setSeach(e.target.value)}/>
      </div>
      {orders ? (
        <>
          {orders.length === 0 ? (
            <>
              <section id="hero">
                <div className="hero-container">
                  <div className="hero-logo">
                    <h1 className="font-weight-bold">No Orders Found</h1>
                  </div>
                </div>
              </section>
              <img
                src={emptyOrder}
                className="d-block d-xl-none d-lg-none d-md-none"
                style={{ width: "100%" }}
              />
              <img
                src={emptyOrder}
                className="d-none d-xl-block d-lg-block d-md-block mx-auto"
                style={{ width: "35%" }}
              />
            </>
          ) : (
            <>
              <section id="hero">
                <div className="hero-container">
                  <div className="hero-logo">
                    <h1 className="font-weight-bold">Your Orders</h1>
                  </div>
                </div>
              </section>
              <section className="">
                <div className="container">
                  <div className="cart">
                    <div className="table-responsive">
                      <table className="table">
                        <thead className="thead-dark tableH">
                          <tr>
                            <th scope="col" className="text-white ">
                              Order Number
                            </th>
                            <th scope="col" className="text-white ">
                              Date
                            </th>
                            <th scope="col" className="text-white ">
                              Total Amount
                            </th>
                            <th scope="col" className="text-white ">
                              Total Discount
                            </th>
                            <th scope="col" className="text-white ">
                              Delivery Address
                            </th>
                            <th scope="col" className="text-white ">
                              Payment Method
                            </th>
                            <th scope="col" className="text-white ">
                              Payment Status
                            </th>
                            {/* <th scope="col" className="text-white ">Delivery Status</th> */}
                          </tr>
                        </thead>
                        <tbody>
                          {orders ? (
                            orders.map((data,key) => (
                              
                                <tr key={key}
                                  className="orderslist target"
                                  onClick={() => ordersummary(data.orderNumber)}
                                >
                                  <td className="productId">
                                    {data.orderNumber}
                                  </td>
                                  <td className="quantity">
                                    {data.date.substring(5, 16)}
                                  </td>
                                  <td className="total">{data.totalAmount}</td>
                                  <td className="total">
                                    {data.totalDiscount}
                                  </td>
                                  <td className="total">{data.address}</td>
                                  <td className="total">{data.payment}</td>
                                  <td className="pay">
                                    {data.isBilled === true ? (
                                      <>Paid</>
                                    ) : (
                                      <>Unpaid</>
                                    )}
                                  </td>
                                  {/* <td className="delivery">{data.isBilled === true?<>Delivered</>:<>Not Delivered</>}</td> */}
                                </tr>
                              
                            ))
                          ) : (
                            <></>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </section>
            </>
          )}
        </>
      ) : (
        <>{Loader()}</>
      )}
    </>
  );
};

export default MyOrders;
